import './App.css'

import Product from './Product';

// Product List lives inside the customer area now, so it carries the customer
// header and footer - the public Header sent a signed-in customer back to the
// landing page.
import HeaderCustomer from './components/customer/HeaderCustomer';
import CustomerFooter from './components/customer/CustomerFooter';


function ProductList() {
    return (
        <div className="custShell">
            <HeaderCustomer />

            <div className="custMain">
                <Product />
            </div>

            <CustomerFooter />
        </div>
    )
}
export default ProductList;
